<template>
    <div class="share-app-menu" ref="share">
        <div class="share-app-menu--wrapper">
            <div class="share-app-menu--container">
                <header class="share-app-menu--header">
                    <h2 class="share-app-menu--title" >Share Application</h2>
                    <div class="share-app-menu--skip" @click="close(true)"><svg-icon name="close" /></div>
                </header>

                <div class="share-app-menu--body" @click="copy">
                    <span class="link"> {{ share_url }}</span>
                    <!-- <span class="btn">Copy</span> -->
                </div>

                <footer>
                    <ui-button @click="copy" color="dark-blue" size="32" :style="'border-square'">Copy URL</ui-button>
                    <ui-button @click="openUrl()" color="dark-blue" size="32" :style="'bg-square'">View application</ui-button>
                </footer>
            </div>
            <div class="share-app-menu--bg" @click="close(false)"></div>
        </div>
    </div>
        
</template>

<script>
import copyToClipboard from 'copy-to-clipboard';

export default {
    name: 'ShareApp',
    
    props: {
        share_url: {
            type: String,
            default: ''
        }
    },

    methods: {
        open() {

            this.$refs.share.classList.add('open');

            setTimeout(() => {
                this.$refs.share.classList.add('open-bg');
            }, 10);

            setTimeout(() => {
                this.$refs.share.classList.add('open-container');
            }, 150);
        },

        close(is_click_button_close) {            
            if (this.$refs.share) this.$refs.share.classList.remove('open-container');
            
            setTimeout(() => {
                if (this.$refs.share) this.$refs.share.classList.remove('open-bg');
            }, 200);

            setTimeout(() => {
                if (this.$refs.share) this.$refs.share.classList.remove('open');
                this.$emit('closeCallback');

                if (is_click_button_close) {
                    this.$emit('callback');
                }
            }, 300);
        },

        openUrl() {
            window.open(this.share_url, '_blank');
            this.close();
        },


        copy() {
            copyToClipboard(this.share_url, {format:'text/plain'});

            this.close();
            this.$notify(`<svg><use xlink:href="#yes--sprite"></use></svg> Link copied`);

        },
    },
}
</script>

<style lang="scss">
    .share-app-menu {
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        z-index: 999999;
        display: none;

        &--wrapper {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            overflow: hidden;
        }

        &--container {
            position: absolute;
            z-index: 9;
            overflow: hidden;
            left: 50%;
            bottom: 0;
            width: 100%;
            transition: transform .3s ease;
            transform: translate3d(-50%, -50%, 0);
            background: white;
            border-radius:  16px;
            max-width: 420px;
            box-shadow: var(--bot-1dp);

                        
            footer {
                display: flex;
                padding: 0 16px 16px;

                .ui-button {
                    text-align: center;
                    justify-content: center;
                    
                    &:nth-child(1) {
                        margin-right: 4px;
                        width: calc(50% - 4px);
                    }

                    &:nth-child(2) {
                        width: calc(50% - 4px);
                        margin-left: 4px;
                    }
                }
            }
        }

        &--bg {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            z-index: 1;
            background: rgba(#000, .8);
            opacity: 0;
            transition: opacity .2s ease;
        }

        &--header {
            padding: 0 8px 0 16px;
            display: flex;
            height: 48px;
            box-sizing: content-box;
            align-items: center;
            // border-bottom: 1px solid var(--black-20);
        }

        &--title {
            font: var(--font-demi-20);
            color: var(--black-90);
            flex: 1;
        }

        &--body {
            color: var(--black-90);
            background: white;
            overflow: hidden;
            padding: 16px;
            display: flex;
            align-items: center;
            cursor: pointer;
        

            .link {
                display: block;
                font-weight: 500;
                color: var(--black-75);
                white-space: nowrap;
                text-overflow: ellipsis;
                overflow: hidden;
                border: 1px solid var(--black-20);
                padding: 0 12px;
                height: 36px;
                line-height: 34px;
                flex: 1;
                border-radius: 8px;
                box-sizing: content-box;
                color: var(--black-90);
            }

        }

        &--skip {        
            color: white;

            svg {
                cursor: pointer;
                height: 12px;
                width: 12px;
                display: block;
                position: relative;
                right: 10px;
                fill: var(--black-50);
            }

            &:hover svg {
                fill: var(--dark-blue);
            }
        }

        &.open {
            display: block;
        }

        &.open-container &--container {
            transform: translate3d(-50%, 0%, 0);
        }

        &.open-bg &--bg {
            opacity: 1;
        }
    }

    @media (min-width: 520px) {
        .share-app-menu {

            &--container {
                opacity: 0;
                transition: opacity .2s ease;
                transform: translate3d(-50%, -50%, 0);
                border-radius:  16px;
                right: auto !important;
                bottom: auto !important;
                left: 50%;
                top: 50%;
            }


            &.open-container &--container {
                transform: translate3d(-50%, -50%, 0);
            }

            &.open-bg &--container,
            &.open-bg &--bg {
                opacity: 1;
            }
        }
    }
</style>
